import initializeComponent from 'Shared/react-initialize';
import { initializeChakraComponent } from 'Shared/chakra-initialize';

import { setSelectedOption } from 'Shared/ifixit_store';
setSelectedOption(App.selectedOption);

import TextComponent from './text_component';
initializeComponent('TextComponent', TextComponent);

import ImageComponent from './image_component';
initializeComponent('ImageComponent', ImageComponent);

import ListComponent from './list_component';
initializeComponent('ListComponent', ListComponent);

import AddToCartComponent from './add_to_cart_component';
initializeChakraComponent('AddToCartComponent', AddToCartComponent);

import VideoComponent from './video_component';
initializeComponent('VideoComponent', VideoComponent);

import FppReviewsComponent from './reviews_component';
initializeComponent('ProductReviews', FppReviewsComponent);

import '../../ProductReviews/stars.js';

import RelatedProductsComponent from './related-products.js';
initializeComponent('RelatedProducts', RelatedProductsComponent);
